module.exports = "{{ name }}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/project-status/project-status.component.html
// module id = ./src/app/shared/project-status/project-status.component.html
// module chunks = main